import React from 'react';
import Header from '../../../Components/Header';
import Footer from '../../../Components/Footer';
import Lpntable from './components/Lpn-table';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function Packingslip() {
  const location = useLocation();
  const deliveryNoteId = location.state?.deliveryNoteId; 
  console.log(deliveryNoteId,"deliveryNoteId");
  

  return (
    <div className='d-flex flex-column' style={{ minHeight: '99.7vh' }}>
      <Helmet>
				<title>Packing Slip List</title>
			</Helmet>
      <Header />
      <Lpntable deliveryNoteId={deliveryNoteId} />
    </div>
  );
}

export default Packingslip;
